import React, { useState, useMemo } from 'react';
import GenericCreate from './GenericCreate';
import useFetch from '../../../hooks/useFetch';
import { Typography } from '@mui/material';
import { useAuth } from '../../../context/AuthContext'; // Adjust path based on your structure
import { apiBase } from '../../../config/axiosConfig';

export const CreateUser = () => {
    const { user, isLoading } = useAuth();
    const userRole = user?.staff_role?.name || null;

    // Base user fields
    const baseFields = {
        first_name: {
            label: 'نام',
            type: 'text',
            required: true,
            validation: null,
        },
        last_name: {
            label: 'نام خانوادگی',
            type: 'text',
            required: true,
            validation: null,
        },
        national_id: {
            label: 'شماره ملی',
            type: 'text',
            required: true,
            validation: null,
        },
        email: {
            label: 'ایمیل',
            type: 'email',
            required: true,
            validation: null,
        },
        mobile: {
            label: 'شماره موبایل',
            type: 'text',
            required: false,
            validation: null,
        },
        address: {
            label: 'آدرس',
            type: 'text',
            required: false,
            validation: null,
        },
        birth_date: {
            label: 'تاریخ تولد',
            type: 'date',
            required: false,
            validation: null,
        },
        password: {
            label: 'پسورد',
            type: 'password',
            required: true,
            validation: null,
        },
        password2: {
            label: 'تکرار پسورد',
            type: 'password',
            required: true,
            validation: null,
        },
    };

    // Dynamic fields for managers
    const managerFields = {
        ...baseFields,
        profile_type: {
            label: 'نوع کاربر',
            type: 'select',
            required: true,
            options: [
                { value: 'student', label: 'هنرجو' },
                { value: 'teacher', label: 'آموزگار' },
                { value: 'staff', label: 'کارمند' },
            ],
        },
        role: {
            label: 'نقش کارمند',
            type: 'select',
            required: false,
            options: [
                { value: 'secretary', label: 'دفتردار' },
                { value: 'accountant', label: 'حسابدار' },
            ],
            condition: (formData) => formData.profile_type === 'staff',
        },
    };

    const secretaryFields = {
        ...baseFields,
        // profile_type is fixed in initialState
    };

    const userConfig = {
        fields: userRole === 'manager' ? managerFields : secretaryFields,
        requiredFields: ['first_name', 'last_name', 'national_id', 'email', 'password', 'password2', ...(userRole === 'manager' ? ['profile_type'] : [])],
        farsiOnlyFields: ['first_name', 'last_name', 'address', 'birth_date'],
        englishOnlyFields: ['email', 'password', 'password2'],
        postSubmit: (response) => {
            console.log('User created:', response);
        },
    };

    // Initial state
    const initialState = {
        first_name: '',
        last_name: '',
        national_id: '',
        email: '',
        mobile: '',
        address: '',
        birth_date: '',
        password: '',
        password2: '',
        profile_type: userRole === 'secretary' ? 'student' : '',
        role: '',
        student_data: {},
        teacher_data: {},
        staff_data: {},
    };

    if (isLoading) {
        return <Typography align="center">در حال بارگذاری...</Typography>;
    }

    if (!user) {
        return <Typography color="error">لطفا وارد شوید.</Typography>;
    }

    if (!['manager', 'secretary'].includes(userRole)) {
        return <Typography color="error">شما اجازه ساخت کاربر ندارید.</Typography>;
    }

    return (
        <GenericCreate
            formTitle="ساخت کاربر"
            initialState={initialState}
            submitUrl={`${apiBase}/accounts/api/v1/register/`}
            instanceConfig={userConfig}
            userRole={userRole}
        />
    );
};

export const CreateClassroom = () => {
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(false);
    const teachersFetchUrl = `${apiBase}/accounts/api/v1/profile/teachers/`;

    const classroomConfig = {
        fields: {
            class_number: {
                label: 'شماره کلاس',
                type: 'text',
                required: true,
                validation: null, // Could be a function or validation schema
            },
            class_name: {
                label: 'نام کلاس',
                type: 'text',
                required: true,
                validation: null,
            },
            capacity: {
                label: 'ظرفیت',
                type: 'text',
                required: true,
                validation: null,
            },
        },
        requiredFields: ['class_number', 'class_name', 'capacity'],
        farsiOnlyFields: ['class_name'],
        postSubmit: (response) => { /* Custom post-submit logic */ },
        // Additional configuration as needed
    };

    return (
        <GenericCreate
            formTitle="ایجاد کلاس جدید"
            initialState={{
                class_number: '',
                class_name: '',
                capacity: '',
            }}
            submitUrl={`${apiBase}/institutes/api/v1/classrooms/`}
            instanceConfig={classroomConfig}
        />
    );
};

